import { useEffect, useState } from "react";
import { useAuth } from "@/context/Auth";

/**
 * Returns the current user's display name.
 * Priority: user_metadata.display_name → email username → email
 * No direct table access — reads from JWT metadata only.
 */
export function useDisplayName() {
  const { session } = useAuth();
  const [displayName, setDisplayName] = useState<string>("");

  useEffect(() => {
    if (!session?.user) {
      setDisplayName("");
      return;
    }

    const meta = session.user.user_metadata;
    const email = session.user.email ?? "";

    // Use display_name from JWT metadata (set at signup / profile update)
    if (meta?.display_name) {
      setDisplayName(meta.display_name);
    } else {
      // Fallback: email username part
      setDisplayName(email.split("@")[0] || email);
    }
  }, [session?.user?.id]);

  return displayName;
}
